import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, heroBadges } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[100svh] w-full flex-col justify-center bg-slate-950 px-5 py-5 text-white sm:py-10" data-id="element-90" data-mp="9kte1nsdw2xr">
      <div className="mx-auto flex w-full max-w-[880px] flex-col items-center text-center" data-id="element-91" data-mp="4m8mecr76rkx">
        <h1 className="text-balance text-[clamp(1.45rem,5vw,3rem)] font-extrabold uppercase leading-[0.98] tracking-tight" data-id="element-92" data-mp="1297f6cerrfdj">
          The Done-for-You System to{' '}
          <span className="text-orange-500" data-id="element-93" data-mp="x8b6zmndx72b">
            Plan an Entire Year of Health Education
          </span>{' '}
          in Just 5 Minutes
        </h1>

        <p className="mt-3 max-w-[660px] text-[clamp(0.82rem,2.5vw,1.05rem)] leading-snug text-white/90" data-id="element-94" data-mp="nb6n5th0hnoo">
          Stop searching for materials:{' '}
          <strong className="font-extrabold text-white" data-id="element-95" data-mp="382ff5o82r4ex">
            lessons, activities, worksheets, assessments and yearly planning
          </strong>{' '}
          in{' '}
          <strong className="font-extrabold text-white" data-id="element-96" data-mp="3j9alrqbghebh">
            one organized system
          </strong>
          , so you walk into class knowing exactly what to teach.
        </p>

        <p className="mt-2 text-[clamp(0.8rem,2.4vw,0.95rem)] font-bold text-white" data-id="element-97" data-mp="399tc6xt32ga8">
          Choose. Open. Teach with confidence.
        </p>

        <img src={BOX_IMAGE} alt="The HEALTH READY™ Complete Bundle: 6 volumes plus lesson plans, printable worksheets, classroom activities, assessments, projects, answer keys and a yearly planner for Middle & High School teachers" className="mt-3 max-h-[38svh] w-auto max-w-full object-contain sm:mt-5 sm:max-h-[48svh]" width={1240} height={1240} data-id="element-98" data-mp="30ib0p0730onh" />

        <CtaButton label="Yes! I Want the System" href="#offer" className="mt-4 w-full max-w-[420px] sm:mt-6" data-id="element-99" data-mp="2hinawe1mmcjd" />

        <p className="mt-2.5 text-[clamp(0.7rem,2vw,0.85rem)] font-extrabold uppercase tracking-tight text-orange-500" data-id="element-100" data-mp="2ljz1omw8l3t5">
          Get HEALTH READY™ Today
        </p>

        <ul className="mt-2.5 flex max-w-[760px] flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[clamp(0.6rem,1.8vw,0.72rem)] font-bold uppercase tracking-wide text-white" data-id="element-101" data-mp="naa0oqsklilz">
          {heroBadges.map((badge, index) => <li key={badge} className={`items-center gap-1.5 ${index < 3 ? 'flex' : 'hidden sm:flex'}`} data-id="element-102" data-mp="db2c17gdy1jk" data-mpi={index}>
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="161aul0eu2nyo" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}